import { render, staticRenderFns } from "./LevelPriceCard.vue?vue&type=template&id=3d5f027a&scoped=true"
import script from "./LevelPriceCard.vue?vue&type=script&lang=js"
export * from "./LevelPriceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f027a",
  null
  
)

export default component.exports